var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { DD_FORM_SIGNATURE_STYLES } from '../../types/dd-forms';
import { selectFeatureFlags, selectRequiredJobs } from './slice-link-params';
export var initialState = {
    initialized: false,
    employerName: null,
    userName: null,
    signatureStyle: DD_FORM_SIGNATURE_STYLES[0],
    isEditFlow: false,
    bankInfos: [],
    formUrl: null,
    loading: false,
    entryPoint: null,
};
export var fetchAccountInformation = createAsyncThunk('ddForm/fetchAccountInformation', function (_a) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, getClient, initializeClient, client, accountInfo;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = require('../../clients/link-api'), getClient = _b.getClient, initializeClient = _b.initializeClient;
                    client = getClient();
                    if (!client) {
                        client = initializeClient(linkToken, uniqueUserId, {
                            __headers: {
                                modal_session_id: modalSessionId,
                            },
                        });
                    }
                    return [4 /*yield*/, client.fetchAccountInformation()];
                case 1:
                    accountInfo = _c.sent();
                    return [2 /*return*/, accountInfo];
            }
        });
    });
});
export var ddFormSlice = createSlice({
    name: 'ddForm',
    initialState: initialState,
    reducers: {
        setEmployerName: function (state, action) { return (__assign(__assign({}, state), { initialized: true, employerName: action.payload })); },
        setUserName: function (state, action) { return (__assign(__assign({}, state), { initialized: true, userName: action.payload })); },
        setSignatureStyle: function (state, action) { return (__assign(__assign({}, state), { initialized: true, signatureStyle: action.payload })); },
        setBankInfos: function (state, action) { return (__assign(__assign({}, state), { initialized: true, bankInfos: action.payload })); },
        setIsEditFlow: function (state, action) { return (__assign(__assign({}, state), { initialized: true, isEditFlow: action.payload })); },
        setFormUrl: function (state, action) { return (__assign(__assign({}, state), { initialized: true, formUrl: action.payload })); },
        setDDFormEntryPoint: function (state, action) { return (__assign(__assign({}, state), { initialized: true, entryPoint: action.payload })); },
    },
    extraReducers: function (builder) {
        builder.addCase(fetchAccountInformation.fulfilled, function (state, action) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, state), { loading: false, employerName: (_a = action.payload.employment) === null || _a === void 0 ? void 0 : _a.employerName, userName: (_b = action.payload.identity) === null || _b === void 0 ? void 0 : _b.fullName, bankInfos: ((_c = action.payload.allocation) === null || _c === void 0 ? void 0 : _c.targets) || [], error: (_d = action.payload.error) === null || _d === void 0 ? void 0 : _d.message }));
        });
        builder.addCase(fetchAccountInformation.pending, function (state) { return (__assign(__assign({}, state), { loading: true })); });
        builder.addCase(fetchAccountInformation.rejected, function (state, action) { return (__assign(__assign({}, state), { loading: false, error: action.error.message })); });
    },
});
export var setEmployerName = (_a = ddFormSlice.actions, _a.setEmployerName), setUserName = _a.setUserName, setSignatureStyle = _a.setSignatureStyle, setBankInfos = _a.setBankInfos, setIsEditFlow = _a.setIsEditFlow, setFormUrl = _a.setFormUrl, setDDFormEntryPoint = _a.setDDFormEntryPoint;
export var selectEmployerName = function (state) {
    return state.ddForm.employerName;
};
export var selectUserName = function (state) { return state.ddForm.userName; };
export var selectSignatureStyle = function (state) {
    return state.ddForm.signatureStyle;
};
export var selectBankInfos = function (state) { return state.ddForm.bankInfos; };
export var selectIsEditFlow = function (state) { return state.ddForm.isEditFlow; };
export var selectFormUrl = function (state) { return state.ddForm.formUrl; };
export var selectDDFormLoading = function (state) { return state.ddForm.loading; };
export var selectDDFormError = function (state) { return state.ddForm.error; };
export var selectDepositFormsLinkTokenSetting = function (state) { var _a, _b; return (_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.depositForms; };
export var selectDDFormEntryPoint = function (state) {
    return state.ddForm.entryPoint;
};
export var selectShouldShowDDFormsFallback = createSelector([selectFeatureFlags, selectRequiredJobs, selectDepositFormsLinkTokenSetting], function (featureFlags, requiredJobs, depositFormsLinkTokenSetting) {
    return ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.directDepositForms) &&
        requiredJobs.includes('direct_deposit_switch') &&
        depositFormsLinkTokenSetting === 'fallback');
});
export default ddFormSlice.reducer;
